import { setCurrentUser, start } from "@store/features/auth";

import { AppThunk } from "@store";
import { IUser } from "@defs/user";
import authService from "@http/services/auth.service";

export const fetchCurrentUser = (): AppThunk => {
  return async (dispatch) => {
    dispatch(start());
    const result = await authService.fetchUser();

    if (result) {
      dispatch(setCurrentUser(result as IUser));
    }
  };
};
